import React from 'react';
import DataGrid,{ Column, Export } from 'devextreme-react/data-grid';
import { store } from '../../services/store';
import uri from '../../utils/uri';
import BlockHeader from '../shared/BlockHeader';
import Title from '../shared/Title';

const Appointment = props => {

    const { id } = props;

    let dataGrid = React.createRef();

    const onToolbarPreparing = (e) => {  
        e.toolbarOptions.items.unshift({
            location: 'before',
            widget: 'dxButton',
            options: {
                text: 'Exportar a excel',
                icon:'xlsxfile',
                type:'success',
                stylingMode:"outlined",
                onClick: () =>  dataGrid.current.instance.exportToExcel(false)
            }
        });
    }  

    const title = "Citas"

    return (
        <div>
            <Title title={title} />
            <BlockHeader title={title} >               
            </BlockHeader>
            <DataGrid
                ref={dataGrid}
                dataSource={store({ uri: {
                    get :uri.appointments.getByClientId(id) 
                } 
                 })}
                selection={{ mode: 'single' }}
                showBorders={true}
                showRowLines={true}
                allowColumnResizing={true}
                allowColumnReordering={true}
                hoverStateEnabled={true}
                rowAlternationEnabled={true}
                onToolbarPreparing={onToolbarPreparing}
            >                
                <Export enabled={false} fileName={title} allowExportSelectedData={true} />
                <Column dataField="dateTime" caption="Fecha" width={160} dataType="date" format="dd/MM/yyyy hh:mm a" />
                <Column dataField="doctor" caption="Doctor" allowFiltering={false} />               
                <Column dataField="activity" caption="Actividad" allowFiltering={false} />
                <Column dataField="note" caption="Nota" allowFiltering={false} />               
            </DataGrid>
        </div>
    );
}

export default Appointment;
